const updateMultiSelectInput = (select, opener) => {
  const selectedOptions = Array.from(
    select.querySelectorAll(".select-option.selected")
  );
  const selectedValues = selectedOptions.map((option) => option.innerText);
  opener.value = selectedValues.join(", ");
};

const Select = () => {
  const selects = Array.from(document.querySelectorAll(".select"));
  if (selects.length > 0) {
    selects.forEach((select) => {
      select.addEventListener("click", (event) => {
        event.stopPropagation();
      });
      const opener = select.querySelector(".select-opener");
      const option = select.querySelector(".select__options");

      opener.addEventListener("click", (event) => {
        event.stopPropagation(); 
        const isActive = select.classList.contains("active");
        
        selects.forEach((s) => s.classList.remove("active"));

        if (isActive) {
          select.classList.remove("active");
        } else {
          select.classList.add("active");
        }
      });

      option.addEventListener("click", (event) => {
        event.preventDefault();
        if (event.target.classList.contains("select-option")) {
          if (select.classList.contains("multi-select")) {
            event.target.classList.toggle("selected");
            updateMultiSelectInput(option, opener);
          } else {
            opener.value = event.target.innerText;
            select.classList.remove("active");
          }
        }
      });
    });

    document.addEventListener("click", (event) => {
      const activeselects = selects.filter((select) =>
        select.classList.contains("active")
      );
      if (activeselects.length > 0) {
        activeselects.forEach((select) => select.classList.remove("active"));
      }
    });
  }
};
export default Select;
